import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@pella/sash-framework';

const APPTTimeslot = ({ onClick, timeslot, selected, disabled }) => (
	<Button
		className={`!text-subtitle-2 mb-2 min-h-[54px] w-full rounded-[3px] border-0 !p-2  ${selected ? '!bg-black !text-white' : '!bg-gray-15 !text-black'}`}
		color='secondary'
		onClick={() => {
			onClick(timeslot.arrayPosition);
		}}
		type='button'
		disabled={disabled}
	>
		{`${timeslot.time} ${timeslot.period}`}
	</Button>
);

APPTTimeslot.propTypes = {
	timeslot: PropTypes.object.isRequired,
	onClick: PropTypes.func.isRequired,
	selected: PropTypes.bool,
	disabled: PropTypes.bool,
};

export default APPTTimeslot;
